import * as React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import { CreateRequestCategoryForm } from "./CreateRequestCategory";

interface CreateRequestCategoryDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

const CreateRequestCategoryDialog: React.FC<CreateRequestCategoryDialogProps> = ({
  open,
  onOpenChange,
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[500px] h-[60vh] p-0 flex flex-col gap-0">
        <DialogHeader className="px-4 py-3 border-b">
          <DialogTitle>Create New Category</DialogTitle>
        </DialogHeader>
        <div className="flex-1 overflow-hidden">
          <CreateRequestCategoryForm
            onCancel={() => onOpenChange(false)}
            onSuccess={() => onOpenChange(false)}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default CreateRequestCategoryDialog;
